import { Component, inject, untracked } from '@angular/core';
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { VxErrorComponent } from '@libs/core/lib/error-view/error-view.component';
import { NgEventBus } from '@libs/core/lib/event-bus/ng-event-bus';
import { VxLoadingComponent } from '@libs/core/lib/shared/loading-state';
import { VxDynamicImageComponent } from '@libs/core/lib/shared/mtjr-image.component';
import { withWishList } from '@libs/mtjr/shared/generated/entities/product/product-store-features';
import { VxProductCardComponent } from '@libs/mtjr/shared/products/product_card.component';
import { signalStore } from '@ngrx/signals';
import { TranslatePipe } from '@ngx-translate/core';

export const WishlistStore = signalStore(withWishList());

@Component({
  selector: 'mac-wishlist',
  providers: [WishlistStore],
  imports: [
    VxDynamicImageComponent,
    VxLoadingComponent,
    VxErrorComponent,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    VxProductCardComponent,
    TranslatePipe,
    IonButtons,
    IonMenuButton,
  ],
  template: `
    <ion-header collapse="fade">
      <ion-toolbar>
        <ion-title>{{ 'USER.WISHLIST' | translate }}</ion-title>
        <ion-buttons slot="start">
          <ion-menu-button class="text-primary" mode="md" />
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="pt-4">
        @switch (store.wishListState().type) {
          @case ('loading') {
            <mtjr-loading></mtjr-loading>
          }
          @case ('error') {
            <mtjr-error [failure]="store.productsFailure()" />
          }
          @case ('success') {
            <div
              class="xs:grid-cols-3 grid grid-cols-2 gap-2 px-4 pb-36 md:mt-4 md:grid-cols-[repeat(auto-fit,minmax(200px,1rem))] md:gap-2"
            >
              @for (product of store.products(); track $index) {
                <mtjr-product-card [product]="product" />
              }
            </div>

            @if (store.products().length === 0) {
              <div class="flex w-full flex-col items-center justify-center">
                <mtjr-dynamic-img
                  src="/assets/no_products.svg"
                  darkSrc="/assets/no_products_dark.svg"
                  class="size-[180px] opacity-80 dark:opacity-70"
                />
                <p class="text-medium/70 mt-5 text-center">
                  {{ 'USER.WISHLIST_EMPTY' | translate }}
                  <br />
                </p>
              </div>
            }
          }
        }
      </div>
    </ion-content>
  `,
})
export class WishlistPage {
  store = inject(WishlistStore);
  eventBus = inject(NgEventBus);
  constructor() {
    this.store.wishListPage();
    this.eventBus.on('wishlist:updated').subscribe(() => {
      untracked(() => {
        this.store.wishListPage({ page: 1 });
      });
    });
  }
}
